<template>
    <el-card class="article-card" :body-style="{ padding: '28px 32px' }">
        <!-- 文章标题区域 -->
        <div class="article-header">
            <div class="title-row">
                <a @click="view(id)" class="article-title">{{title}}</a>
                <span v-if="weight > 0" class="top-badge">置顶</span>
            </div>
            
            <!-- 元信息 -->
            <div class="article-meta">
                <span class="meta-item author">
                    <i class="el-icon-user"></i>{{author}}
                </span>
                <span class="meta-item">
                    <i class="el-icon-time"></i>{{createDate | format}}
                </span>
                <span class="meta-item stats">
                    <i class="el-icon-view"></i>{{viewCounts}}
                </span>
                <span class="meta-item stats">
                    <i class="el-icon-chat-line-round"></i>{{commentCounts}}
                </span>
            </div>
        </div>

        <!-- 摘要 -->
        <div class="article-summary" v-if="summary">
            {{summary}}
        </div>

        <!-- 标签区域 -->
        <div class="article-footer" v-if="tags && tags.length">
            <div class="tag-list">
                <span v-for="t in tags" :key="t.tagName" class="article-tag">
                    {{t.tagName}}
                </span>
            </div>
        </div>
    </el-card>
</template>

<script>
    export default {
        name: "ArticleItem",
        props:
            {
                id: String,
                weight: Number,
                title: String,
                commentCounts: Number,
                viewCounts: Number,
                summary: String,
                author: String,
                tags: Array,
                createDate: String
            },
        methods:
            {
                /*点击文章标题，跳转到文章详情*/
                view(id) {
                    this.$router.push({path: `/view/${id}`})
                }
            }
    }
</script>

<style scoped>
    /* 文章卡片 - 极简高级 */
    .article-card {
        margin-bottom: 20px;
    }

    .article-card :deep(.el-card__body) {
        padding: 28px 32px !important;
    }

    /* 标题区域 */
    .article-header {
        margin-bottom: 16px;
    }

    .title-row {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 12px;
    }

    .article-title {
        font-size: 18px;
        font-weight: 600;
        color: var(--text-primary);
        line-height: 1.4;
        letter-spacing: -0.2px;
        transition: color 0.25s ease;
        cursor: pointer;
    }

    .article-title:hover {
        color: var(--accent-warm);
    }

    /* 置顶标签 - 莫兰迪色系 */
    .top-badge {
        display: inline-flex;
        align-items: center;
        padding: 4px 10px;
        background: linear-gradient(135deg, var(--accent-soft) 0%, #f5e6d3 100%);
        color: var(--accent-warm);
        font-size: 11px;
        font-weight: 600;
        border-radius: 20px;
        letter-spacing: 0.5px;
        text-transform: uppercase;
    }

    /* 元信息 - 精致小字 */
    .article-meta {
        display: flex;
        align-items: center;
        gap: 20px;
        flex-wrap: wrap;
    }

    .meta-item {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: var(--text-tertiary);
        font-weight: 400;
    }

    .meta-item i {
        font-size: 13px;
        opacity: 0.7;
    }

    .meta-item.author {
        color: var(--text-secondary);
        font-weight: 500;
    }

    .meta-item.stats {
        color: var(--text-tertiary);
    }

    /* 摘要 - 优雅正文 */
    .article-summary {
        font-size: 14px;
        line-height: 1.8;
        color: var(--text-secondary);
        margin-bottom: 20px;
        letter-spacing: 0.2px;
    }

    /* 标签区域 */
    .article-footer {
        padding-top: 16px;
        border-top: 1px solid var(--border-light);
    }

    .tag-list {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .article-tag {
        display: inline-flex;
        align-items: center;
        padding: 5px 12px;
        background: var(--bg-secondary);
        color: var(--text-secondary);
        font-size: 12px;
        font-weight: 500;
        border-radius: var(--radius-sm);
        transition: all 0.2s ease;
        cursor: pointer;
    }

    .article-tag:hover {
        background: var(--accent-warm);
        color: white;
    }

    /* 响应式 */
    @media (max-width: 768px) {
        .article-card :deep(.el-card__body) {
            padding: 20px 24px !important;
        }
        
        .article-title {
            font-size: 16px;
        }
        
        .article-meta {
            gap: 12px;
        }
    }
</style>